import type { ColumnKey } from 'components/QDataGrid/useQdgPrefs';

type ColumnSizeFields = { width?: number; flex?: number; minWidth?: number; maxWidth?: number; resizable?: boolean };
// This defines the default sizing configuration for each column in QDataGridRegister. All columns used in any
// QDataGridRegister should have an entry here. When updating, consider the following:
//   - If flex is defined, then the column is flexible and will grow/shrink based on available space.
//   - If width is defined, then the column is fixed (can still be resized by user if resizable=true).
//   - If minWidth or maxWidth, this sets bounds for flexible columns and user resizing.
//   - Do not define both flex and width. If both are defined, flex takes precedence.
//
export const ColumnSizes: Partial<Record<ColumnKey, ColumnSizeFields>> = {
  account: { width: 135, minWidth: 50, maxWidth: 600, resizable: true },
  action: { width: 150, minWidth: 72, resizable: true },
  amount: { width: 120, minWidth: 100, maxWidth: 200, resizable: true },
  attachments: { width: 50, resizable: false },
  category: { width: 150, minWidth: 100, maxWidth: 600, resizable: true },
  check: { width: 80, minWidth: 50, maxWidth: 200, resizable: true },
  clientAndProject: { width: 120, minWidth: 50, maxWidth: 600, resizable: true },
  cpPayee: { flex: 2, minWidth: 150, maxWidth: 600, resizable: true },
  date: { width: 125, resizable: false },
  exclusion: { width: 60, resizable: false },
  fee: { width: 120, minWidth: 50, resizable: true },
  flag: { width: 50, resizable: false },
  isInvoiceTxn: { width: 50, resizable: false },
  notes: { flex: 2, minWidth: 100, maxWidth: 600, resizable: true },
  payee: { flex: 2, minWidth: 150, maxWidth: 600, resizable: true },
  price: { width: 120, minWidth: 100, resizable: true },
  quantity: { width: 120, minWidth: 100, resizable: true },
  reviewed: { width: 50, resizable: false },
  series: { width: 50, resizable: false },
  split: { width: 50, resizable: false },
  status: { width: 86, minWidth: 50, maxWidth: 86, resizable: true },
  tags: { flex: 1, minWidth: 100, resizable: true },
  threeDotMenu: { width: 42, minWidth: 42, resizable: false },
  unpaid: { width: 120, minWidth: 100, resizable: true },
  usage: { width: 50, resizable: false },
} as const;
